import React, { useEffect } from 'react';
import Library from 'library';
export default () => {
    useEffect(() => {
        window.location.href = Library.Util.RECHARGE_CARD_DOWNLOAD_URL;
    }, []);
    return false;
};
